import axios from "axios"
const controller = "/empleado"
const EmpleadoService = {
    paginar: async (request) => {
        const { data } = await axios.post(`${controller}/paginar`, request)
        return data
    },
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrar: async (empleado) => {
        const { data } = await axios.post(`${controller}/registrar`, {
            empleado
        })
        return data
        return null
    },
    cargarEmpleados: async (request) => {
        const { data } = await axios.post(`${controller}/cargarEmpleados`, request)
        return data
    },
    obtener: async (emp_id) => {
        const { data } = await axios.post(`${controller}/obtener`, {
            empleado: {
                emp_id
            }
        })
        return data
    },
    modificar: async (empleado) => {
        const { data } = await axios.post(`${controller}/modificar`, {
            empleado
        })
        return data
    },
    buscarRapido: async (empleado) => {
        const { data } = await axios.post(`${controller}/buscarRapido`, {
            empleado
        })
        return data
    },
    cargarArchivo: async (file, pry_id) => {
        let form = new FormData()
        form.append("file", file)
        form.append("id", pry_id)
        const { data } = await axios.post(`${controller}/cargarArchivo`, form)
        return data
    }
}
export default EmpleadoService